import { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Content from "./Content";
import Forms from "./Forms";
import { deleteTeacher, fetchTeachers } from '../../features/teachers/teachersSlice'
import { fetchDepartments } from "../../features/department/departmentSlice";
import { CustomContainer } from "../Tools";

const Teachers = () => {
    const { status } = useSelector(state => state.teachers)
    const dispatch = useDispatch();
    useEffect(() => {
        if(status === 'idle') {
            dispatch(fetchDepartments())
            dispatch(fetchTeachers())
        }
    }, [dispatch, status])
    const title = 'Profesores';
    return(
        <CustomContainer
            content={<Content />}
            forms={<Forms />}
            fnConfirm={deleteTeacher}
            title={title}
        />
    )
}

export default memo(Teachers);